import React, { useState, useEffect, useContext, useRef } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
	Chip,
	FormControl,
	FormControlLabel,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	Switch,
	Typography,
} from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { AuthContext } from "../../context/Auth/AuthContext";
import { isArray, capitalize } from "lodash";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import AttachFile from "@material-ui/icons/AttachFile";
import { head } from "lodash";
import ConfirmationModal from "../ConfirmationModal";
import MessageVariablesPicker from "../MessageVariablesPicker";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	btnWrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	weekdayChip: {
		margin: theme.spacing(0.5),
	},
	weekdayChipSelected: {
		margin: theme.spacing(0.5),
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
	},
}));

const WEEKDAYS = [
	{ value: 0, label: "Dom" },
	{ value: 1, label: "Seg" },
	{ value: 2, label: "Ter" },
	{ value: 3, label: "Qua" },
	{ value: 4, label: "Qui" },
	{ value: 5, label: "Sex" },
	{ value: 6, label: "Sáb" },
];

const ScheduleSchema = Yup.object().shape({
	body: Yup.string().min(5, "Mensagem muito curta").required("Obrigatório"),
	sendAt: Yup.string().required("Obrigatório"),
});

const ScheduleModal = ({ open, onClose, scheduleId, contactId, cleanContact, reload }) => {
	const classes = useStyles();
	const history = useHistory();
	const { user } = useContext(AuthContext);
	const isMounted = useRef(true);
	const { companyId } = user;
	const isEdit = Boolean(scheduleId);

	const initialState = {
		body: "",
		contactId: "",
		sendAt: moment().add(1, "hour").format("YYYY-MM-DDTHH:mm"),
		sentAt: "",
		openTicket: "enabled",
		ticketUserId: "",
		queueId: "",
		statusTicket: "closed",
		intervalo: 1,
		valorIntervalo: 0,
		enviarQuantasVezes: 1,
		tipoDias: 4,
		assinar: false,
		recurrenceType: "none",
		recurrenceInterval: 1,
		recurrenceWeekdays: "",
		recurrenceEnds: "never",
		recurrenceUntil: "",
		recurrenceCount: 5,
	};

	const initialContact = {
		id: "",
		name: "",
		channel: "",
	};

	const [schedule, setSchedule] = useState(initialState);
	const [currentContact, setCurrentContact] = useState(initialContact);
	const [currentContacts, setCurrentContacts] = useState([]);
	const [contacts, setContacts] = useState([]);
	const [tipoDias, setTipoDias] = useState(4);
	const [recurrenceType, setRecurrenceType] = useState("none");
	const [recurrenceInterval, setRecurrenceInterval] = useState(1);
	const [recurrenceUnit, setRecurrenceUnit] = useState(1); // 1d 2w 3m 5y (custom)
	const [selectedWeekdays, setSelectedWeekdays] = useState([]);
	const [recurrenceEnds, setRecurrenceEnds] = useState("never");
	const [recurrenceUntil, setRecurrenceUntil] = useState("");
	const [recurrenceCount, setRecurrenceCount] = useState(5);
	const [attachment, setAttachment] = useState(null);
	const attachmentFile = useRef(null);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const messageInputRef = useRef();
	const [channelFilter, setChannelFilter] = useState("whatsapp");
	const [whatsapps, setWhatsapps] = useState([]);
	const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
	const [loading, setLoading] = useState(false);
	const [queues, setQueues] = useState([]);
	const [allQueues, setAllQueues] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);
	const [selectedQueue, setSelectedQueue] = useState(null);
	const { findAll: findAllQueues } = useQueues();
	const [options, setOptions] = useState([]);
	const [searchParam, setSearchParam] = useState("");

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		if (isMounted.current) {
			const loadQueues = async () => {
				const list = await findAllQueues();
				setAllQueues(list);
				setQueues(list);
			};
			loadQueues();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (searchParam.length < 3) {
			setLoading(false);
			setSelectedQueue("");
			return;
		}
		const delayDebounceFn = setTimeout(() => {
			setLoading(true);
			const fetchUsers = async () => {
				try {
					const { data } = await api.get("/users/");
					setOptions(data.users);
					setLoading(false);
				} catch (err) {
					setLoading(false);
					toastError(err);
				}
			};

			fetchUsers();
		}, 500);
		return () => clearTimeout(delayDebounceFn);
	}, [searchParam]);

	useEffect(() => {
		api
			.get(`/whatsapp/filter`, { params: { session: 0, channel: channelFilter } })
			.then(({ data }) => {
				const mappedWhatsapps = data.map((whatsapp) => ({
					...whatsapp,
					selected: false,
				}));

				setWhatsapps(mappedWhatsapps);
				if (mappedWhatsapps.length && mappedWhatsapps?.length === 1) {
					setSelectedWhatsapps(mappedWhatsapps[0].id);
				}
			});
	}, [currentContact, currentContacts, channelFilter]);

	useEffect(() => {
		if (contactId && contacts.length && !scheduleId) {
			const contact = contacts.find((c) => c.id === contactId);
			if (contact) {
				setCurrentContacts([contact]);
				setCurrentContact(contact);
				setChannelFilter(contact.channel || "whatsapp");
			}
		}
	}, [contactId, contacts, scheduleId]);

	const applyRecurrenceFromData = (data) => {
		const type = data.recurrenceType || "none";
		setRecurrenceType(type);
		setRecurrenceInterval(data.recurrenceInterval || 1);
		setRecurrenceEnds(data.recurrenceEnds || "never");
		setRecurrenceCount(data.recurrenceCount || 5);
		setRecurrenceUntil(
			data.recurrenceUntil
				? moment(data.recurrenceUntil).format("YYYY-MM-DDTHH:mm")
				: ""
		);
		setTipoDias(data.tipoDias || 4);

		if (data.recurrenceWeekdays) {
			setSelectedWeekdays(
				String(data.recurrenceWeekdays)
					.split(",")
					.map((s) => Number(s.trim()))
					.filter((n) => !Number.isNaN(n))
			);
		} else if (data.sendAt) {
			setSelectedWeekdays([moment(data.sendAt).day()]);
		}

		if (type === "custom") {
			setRecurrenceUnit(data.intervalo || 1);
		} else if (type === "daily") {
			setRecurrenceUnit(1);
		} else if (type === "weekly") {
			setRecurrenceUnit(2);
		} else if (type === "monthly") {
			setRecurrenceUnit(3);
		} else if (type === "yearly") {
			setRecurrenceUnit(5);
		}

		// Legado sem recurrenceType
		if ((!data.recurrenceType || data.recurrenceType === "none") && data.valorIntervalo > 0) {
			setRecurrenceType("custom");
			setRecurrenceInterval(data.valorIntervalo);
			setRecurrenceUnit(data.intervalo || 1);
			setRecurrenceEnds("after_count");
			setRecurrenceCount(data.enviarQuantasVezes || 1);
		}
	};

	useEffect(() => {
		if (open) {
			try {
				(async () => {
					const { data: contactList } = await api.get("/contacts/list", {
						params: { companyId: companyId },
					});
					let customList = contactList.map((c) => ({
						id: c.id,
						name: c.name,
						channel: c.channel,
					}));
					if (isArray(customList)) {
						setContacts(customList);
					}
					if (contactId && !scheduleId) {
						setSchedule((prevState) => {
							return { ...prevState, contactId };
						});
					}

					if (!scheduleId) {
						setRecurrenceType("none");
						setSelectedWeekdays([moment().day()]);
						return;
					}

					const { data } = await api.get(`/schedules/${scheduleId}`);
					setSchedule((prevState) => {
						return {
							...prevState,
							...data,
							sendAt: moment(data.sendAt).format("YYYY-MM-DDTHH:mm"),
						};
					});
					if (data.whatsapp) {
						setSelectedWhatsapps(data.whatsapp.id);
					}

					if (data.ticketUser) {
						setSelectedUser(data.ticketUser);
					}
					if (data.queueId) {
						setSelectedQueue(data.queueId);
					}

					applyRecurrenceFromData(data);
					setCurrentContact(data.contact || initialContact);
					setCurrentContacts(data.contact ? [data.contact] : []);
					setChannelFilter(data.contact?.channel || "whatsapp");
				})();
			} catch (err) {
				toastError(err);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [scheduleId, contactId, open, user]);

	const filterOptions = createFilterOptions({
		trim: true,
	});

	const handleClose = () => {
		onClose();
		setAttachment(null);
		setSchedule(initialState);
		setCurrentContacts([]);
		setCurrentContact(initialContact);
		setRecurrenceType("none");
		setSelectedWeekdays([]);
	};

	const handleAttachmentFile = (e) => {
		const file = head(e.target.files);
		if (file) {
			setAttachment(file);
		}
	};

	const IconChannel = (channel) => {
		switch (channel) {
			case "facebook":
				return <Facebook style={{ color: "#3b5998", verticalAlign: "middle" }} />;
			case "instagram":
				return <Instagram style={{ color: "#e1306c", verticalAlign: "middle" }} />;
			case "whatsapp":
				return <WhatsApp style={{ color: "#25d366", verticalAlign: "middle" }} />;
			default:
				return "error";
		}
	};

	const renderOption = (option) => {
		if (option.name) {
			return (
				<>
					{IconChannel(option.channel)}
					<Typography
						component="span"
						style={{
							fontSize: 14,
							marginLeft: "10px",
							display: "inline-flex",
							alignItems: "center",
							lineHeight: "2",
						}}
					>
						{option.name}
					</Typography>
				</>
			);
		}
		return `${i18n.t("newTicketModal.add")} ${option.name}`;
	};

	const toggleWeekday = (day) => {
		setSelectedWeekdays((prev) => {
			if (prev.includes(day)) {
				const next = prev.filter((d) => d !== day);
				return next.length ? next : prev;
			}
			return [...prev, day].sort((a, b) => a - b);
		});
	};

	const buildRecurrencePayload = (sendAtValue) => {
		let type = recurrenceType;
		let interval = Math.max(1, Number(recurrenceInterval) || 1);
		let weekdays = "";
		let intervalo = 1;
		let valorIntervalo = 0;
		let enviarQuantasVezes = 1;

		if (type === "none") {
			return {
				recurrenceType: "none",
				recurrenceInterval: 1,
				recurrenceWeekdays: null,
				recurrenceEnds: "never",
				recurrenceUntil: null,
				recurrenceCount: null,
				intervalo: 1,
				valorIntervalo: 0,
				enviarQuantasVezes: 1,
				tipoDias,
			};
		}

		if (type === "daily") {
			intervalo = 1;
			interval = 1;
		} else if (type === "weekly") {
			intervalo = 2;
			interval = 1;
			const days =
				selectedWeekdays.length > 0
					? selectedWeekdays
					: [moment(sendAtValue).day()];
			weekdays = days.join(",");
		} else if (type === "monthly") {
			intervalo = 3;
			interval = 1;
		} else if (type === "yearly") {
			intervalo = 5;
			interval = 1;
		} else if (type === "custom") {
			intervalo = Number(recurrenceUnit) || 1;
			interval = Math.max(1, Number(recurrenceInterval) || 1);
			if (intervalo === 2) {
				const days =
					selectedWeekdays.length > 0
						? selectedWeekdays
						: [moment(sendAtValue).day()];
				weekdays = days.join(",");
			}
		}

		// Compat legado: marca valorIntervalo para fallback se necessário
		valorIntervalo = interval;
		if (recurrenceEnds === "after_count") {
			enviarQuantasVezes = Math.max(1, Number(recurrenceCount) || 1);
		} else {
			enviarQuantasVezes = 9999;
		}

		return {
			recurrenceType: type,
			recurrenceInterval: interval,
			recurrenceWeekdays: weekdays || null,
			recurrenceEnds,
			recurrenceUntil:
				recurrenceEnds === "on_date" && recurrenceUntil
					? moment(recurrenceUntil).toISOString()
					: null,
			recurrenceCount:
				recurrenceEnds === "after_count"
					? Math.max(1, Number(recurrenceCount) || 1)
					: null,
			intervalo,
			valorIntervalo,
			enviarQuantasVezes,
			tipoDias,
			contadorEnvio: 0,
		};
	};

	const handleSaveSchedule = async (values) => {
		const contactIds = isEdit
			? currentContact?.id
				? [Number(currentContact.id)]
				: []
			: currentContacts.map((c) => Number(c.id)).filter(Boolean);

		if (!contactIds.length) {
			toast.error("Selecione ao menos um contato");
			return;
		}

		const recurrencePayload = buildRecurrencePayload(values.sendAt);

		const scheduleData = {
			...values,
			userId: user.id,
			whatsappId: selectedWhatsapps,
			ticketUserId: selectedUser?.id || null,
			queueId: selectedQueue || null,
			...recurrencePayload,
			contactIds,
			contactId: contactIds[0],
		};

		try {
			if (scheduleId) {
				await api.put(`/schedules/${scheduleId}`, scheduleData);
				if (attachment != null) {
					const formData = new FormData();
					formData.append("file", attachment);
					await api.post(`/schedules/${scheduleId}/media-upload`, formData);
				}
			} else {
				const { data } = await api.post("/schedules", scheduleData);
				const createdList = Array.isArray(data) ? data : [data];
				if (attachment != null && createdList.length) {
					const formData = new FormData();
					formData.append("file", attachment);
					const firstId = createdList[0].id;
					await api.post(`/schedules/${firstId}/media-upload`, formData);
					const otherIds = createdList.slice(1).map((s) => s.id);
					if (otherIds.length) {
						await api.post(`/schedules/${firstId}/media-replicate`, {
							scheduleIds: otherIds,
						});
					}
				}
			}
			toast.success(i18n.t("scheduleModal.success"));
			if (typeof reload == "function") {
				reload();
			}
			if (contactId) {
				if (typeof cleanContact === "function") {
					cleanContact();
					history.push("/schedules");
				}
			}
		} catch (err) {
			toastError(err);
		}
		setCurrentContact(initialContact);
		setCurrentContacts([]);
		setSchedule(initialState);
		handleClose();
	};

	const handleClickMsgVar = async (msgVar, setValueFunc) => {
		const el = messageInputRef.current;
		const firstHalfText = el.value.substring(0, el.selectionStart);
		const secondHalfText = el.value.substring(el.selectionEnd);
		const newCursorPos = el.selectionStart + msgVar.length;

		setValueFunc("body", `${firstHalfText}${msgVar}${secondHalfText}`);

		await new Promise((r) => setTimeout(r, 100));
		messageInputRef.current.setSelectionRange(newCursorPos, newCursorPos);
	};

	const deleteMedia = async () => {
		if (attachment) {
			setAttachment(null);
			attachmentFile.current.value = null;
		}

		if (schedule.mediaPath) {
			await api.delete(`/schedules/${schedule.id}/media-upload`);
			setSchedule((prev) => ({
				...prev,
				mediaPath: null,
			}));
			toast.success(i18n.t("scheduleModal.toasts.deleted"));
			if (typeof reload == "function") {
				reload();
			}
		}
	};

	const showWeekdays =
		recurrenceType === "weekly" ||
		(recurrenceType === "custom" && Number(recurrenceUnit) === 2);

	const showBusinessDays =
		recurrenceType !== "none" &&
		!(recurrenceType === "custom" && Number(recurrenceUnit) === 4);

	return (
		<div className={classes.root}>
			<ConfirmationModal
				title={i18n.t("scheduleModal.confirmationModal.deleteTitle")}
				open={confirmationOpen}
				onClose={() => setConfirmationOpen(false)}
				onConfirm={deleteMedia}
			>
				{i18n.t("scheduleModal.confirmationModal.deleteMessage")}
			</ConfirmationModal>
			<Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth scroll="paper">
				<DialogTitle id="form-dialog-title">
					{schedule.status === "ERRO"
						? "Erro de Envio"
						: `Mensagem ${capitalize(schedule.status || "PENDENTE")}`}
				</DialogTitle>
				<div style={{ display: "none" }}>
					<input
						type="file"
						accept=".png,.jpg,.jpeg"
						ref={attachmentFile}
						onChange={(e) => handleAttachmentFile(e)}
					/>
				</div>
				<Formik
					initialValues={schedule}
					enableReinitialize={true}
					validationSchema={ScheduleSchema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSaveSchedule(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ touched, errors, isSubmitting, values, setFieldValue }) => (
						<Form>
							<DialogContent dividers>
								<div>
									<FormControl variant="outlined" fullWidth>
										{isEdit ? (
											<Autocomplete
												fullWidth
												value={currentContact}
												options={contacts}
												disabled
												getOptionLabel={(option) => option.name || ""}
												renderOption={renderOption}
												getOptionSelected={(option, value) => value.id === option.id}
												renderInput={(params) => (
													<TextField {...params} variant="outlined" placeholder="Contato" />
												)}
											/>
										) : (
											<Autocomplete
												fullWidth
												multiple
												value={currentContacts}
												options={contacts}
												onChange={(e, selected) => {
													if (selected instanceof Array) {
														setCurrentContacts(selected);
														const first = selected[0];
														setCurrentContact(first || initialContact);
														setChannelFilter(first?.channel || "whatsapp");
														setSchedule({
															...schedule,
															contactId: first?.id || "",
														});
													}
												}}
												getOptionLabel={(option) =>
													Array.isArray(option) ? "" : option.name || ""
												}
												renderOption={renderOption}
												getOptionSelected={(option, value) => value.id === option.id}
												renderInput={(params) => (
													<TextField
														{...params}
														variant="outlined"
														placeholder="Contatos"
														helperText="Selecione um ou mais contatos para disparar a mesma mensagem"
													/>
												)}
											/>
										)}
									</FormControl>
								</div>
								<div>
									<Field
										as={TextField}
										rows={9}
										multiline={true}
										label={i18n.t("scheduleModal.form.body")}
										name="body"
										inputRef={messageInputRef}
										error={touched.body && Boolean(errors.body)}
										helperText={
											(touched.body && errors.body) ||
											"Variáveis via seletor abaixo. Use {quebra} para dividir em várias mensagens."
										}
										variant="outlined"
										margin="dense"
										fullWidth
									/>
								</div>
								<Grid item xs={12} md={12} xl={6}>
									<MessageVariablesPicker
										disabled={isSubmitting}
										onClick={(value) => handleClickMsgVar(value, setFieldValue)}
									/>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} md={6} xl={6}>
										<FormControl variant="outlined" margin="dense" fullWidth>
											<InputLabel id="whatsapp-selection-label">
												{i18n.t("campaigns.dialog.form.whatsapp")}
											</InputLabel>
											<Field
												as={Select}
												label={i18n.t("campaigns.dialog.form.whatsapp")}
												placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
												labelId="whatsapp-selection-label"
												id="whatsappIds"
												name="whatsappIds"
												required
												error={touched.whatsappId && Boolean(errors.whatsappId)}
												value={selectedWhatsapps}
												onChange={(event) => setSelectedWhatsapps(event.target.value)}
											>
												{whatsapps &&
													whatsapps.map((whatsapp) => (
														<MenuItem key={whatsapp.id} value={whatsapp.id}>
															{whatsapp.name}
														</MenuItem>
													))}
											</Field>
										</FormControl>
									</Grid>
									<Grid item xs={12} md={12} xl={6}>
										<FormControl variant="outlined" margin="dense" fullWidth>
											<InputLabel id="openTicket-selection-label">
												{i18n.t("campaigns.dialog.form.openTicket")}
											</InputLabel>
											<Field
												as={Select}
												label={i18n.t("campaigns.dialog.form.openTicket")}
												placeholder={i18n.t("campaigns.dialog.form.openTicket")}
												labelId="openTicket-selection-label"
												id="openTicket"
												name="openTicket"
												error={touched.openTicket && Boolean(errors.openTicket)}
											>
												<MenuItem value={"enabled"}>
													{i18n.t("campaigns.dialog.form.enabledOpenTicket")}
												</MenuItem>
												<MenuItem value={"disabled"}>
													{i18n.t("campaigns.dialog.form.disabledOpenTicket")}
												</MenuItem>
											</Field>
										</FormControl>
									</Grid>
								</Grid>
								<Grid spacing={1} container>
									<Grid item xs={12} md={6} xl={6}>
										<Autocomplete
											style={{ marginTop: "8px" }}
											variant="outlined"
											margin="dense"
											getOptionLabel={(option) => `${option.name}`}
											value={selectedUser}
											size="small"
											onChange={(e, newValue) => {
												setSelectedUser(newValue);
												if (newValue != null && Array.isArray(newValue.queues)) {
													if (newValue.queues.length === 1) {
														setSelectedQueue(newValue.queues[0].id);
													}
													setQueues(newValue.queues);
												} else {
													setQueues(allQueues);
													setSelectedQueue("");
												}
											}}
											options={options}
											filterOptions={filterOptions}
											freeSolo
											fullWidth
											disabled={values.openTicket === "disabled"}
											autoHighlight
											noOptionsText={i18n.t("transferTicketModal.noOptions")}
											loading={loading}
											renderOption={(option) => (
												<span>
													{" "}
													<UserStatusIcon user={option} /> {option.name}
												</span>
											)}
											renderInput={(params) => (
												<TextField
													{...params}
													label={i18n.t("transferTicketModal.fieldLabel")}
													variant="outlined"
													onChange={(e) => setSearchParam(e.target.value)}
													InputProps={{
														...params.InputProps,
														endAdornment: (
															<React.Fragment>
																{loading ? (
																	<CircularProgress color="inherit" size={20} />
																) : null}
																{params.InputProps.endAdornment}
															</React.Fragment>
														),
													}}
												/>
											)}
										/>
									</Grid>

									<Grid item xs={12} md={6} xl={6}>
										<FormControl variant="outlined" margin="dense" fullWidth>
											<InputLabel>
												{i18n.t("transferTicketModal.fieldQueueLabel")}
											</InputLabel>
											<Select
												value={selectedQueue}
												onChange={(e) => setSelectedQueue(e.target.value)}
												label={i18n.t("transferTicketModal.fieldQueuePlaceholder")}
												disabled={values.openTicket === "disabled"}
											>
												{queues.map((queue) => (
													<MenuItem key={queue.id} value={queue.id}>
														{queue.name}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>
								</Grid>
								<Grid spacing={1} container style={{ marginTop: "-10px" }}>
									<Grid item xs={12} md={6} xl={6}>
										<FormControl variant="outlined" margin="dense" fullWidth>
											<InputLabel id="statusTicket-selection-label">
												{i18n.t("campaigns.dialog.form.statusTicket")}
											</InputLabel>
											<Field
												as={Select}
												disabled={values.openTicket === "disabled"}
												label={i18n.t("campaigns.dialog.form.statusTicket")}
												placeholder={i18n.t("campaigns.dialog.form.statusTicket")}
												labelId="statusTicket-selection-label"
												id="statusTicket"
												name="statusTicket"
												error={touched.statusTicket && Boolean(errors.statusTicket)}
											>
												<MenuItem value={"closed"}>
													{i18n.t("campaigns.dialog.form.closedTicketStatus")}
												</MenuItem>
												<MenuItem value={"open"}>
													{i18n.t("campaigns.dialog.form.openTicketStatus")}
												</MenuItem>
											</Field>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={6} xl={6}>
										<Field
											as={TextField}
											label={i18n.t("scheduleModal.form.sendAt")}
											type="datetime-local"
											name="sendAt"
											error={touched.sendAt && Boolean(errors.sendAt)}
											helperText={touched.sendAt && errors.sendAt}
											variant="outlined"
											fullWidth
											size="small"
											style={{ marginTop: "8px" }}
										/>
									</Grid>
									<Grid item xs={12} md={6} xl={6}>
										<FormControlLabel
											control={
												<Field
													as={Switch}
													color="primary"
													name="assinar"
													checked={values.assinar}
													disabled={values.openTicket === "disabled"}
												/>
											}
											label={i18n.t("scheduleModal.form.assinar")}
										/>
									</Grid>
								</Grid>

								<h3>Recorrência</h3>
								<p>
									Escolha se a mensagem se repete, no estilo do Google Agenda. Use
									Personalizado para intervalo, dias da semana e término.
								</p>
								<br />
								<Grid container spacing={1}>
									<Grid item xs={12} md={6}>
										<FormControl size="small" fullWidth variant="outlined">
											<InputLabel id="recurrence-type-label">Repetir</InputLabel>
											<Select
												labelId="recurrence-type-label"
												value={recurrenceType}
												onChange={(e) => {
													const v = e.target.value;
													setRecurrenceType(v);
													if (v === "weekly" && !selectedWeekdays.length) {
														setSelectedWeekdays([moment(values.sendAt).day()]);
													}
												}}
												label="Repetir"
											>
												<MenuItem value="none">Não repetir</MenuItem>
												<MenuItem value="daily">Diariamente</MenuItem>
												<MenuItem value="weekly">Semanalmente</MenuItem>
												<MenuItem value="monthly">Mensalmente</MenuItem>
												<MenuItem value="yearly">Anualmente</MenuItem>
												<MenuItem value="custom">Personalizado</MenuItem>
											</Select>
										</FormControl>
									</Grid>

									{recurrenceType === "custom" && (
										<>
											<Grid item xs={6} md={3}>
												<TextField
													label="A cada"
													type="number"
													size="small"
													variant="outlined"
													fullWidth
													value={recurrenceInterval}
													onChange={(e) =>
														setRecurrenceInterval(Math.max(1, Number(e.target.value) || 1))
													}
													inputProps={{ min: 1 }}
												/>
											</Grid>
											<Grid item xs={6} md={3}>
												<FormControl size="small" fullWidth variant="outlined">
													<InputLabel id="recurrence-unit-label">Unidade</InputLabel>
													<Select
														labelId="recurrence-unit-label"
														value={recurrenceUnit}
														onChange={(e) => setRecurrenceUnit(e.target.value)}
														label="Unidade"
													>
														<MenuItem value={1}>Dias</MenuItem>
														<MenuItem value={2}>Semanas</MenuItem>
														<MenuItem value={3}>Meses</MenuItem>
														<MenuItem value={5}>Anos</MenuItem>
														<MenuItem value={4}>Minutos</MenuItem>
													</Select>
												</FormControl>
											</Grid>
										</>
									)}

									{showWeekdays && (
										<Grid item xs={12}>
											<Typography variant="body2" gutterBottom>
												Dias da semana
											</Typography>
											{WEEKDAYS.map((wd) => (
												<Chip
													key={wd.value}
													label={wd.label}
													clickable
													className={
														selectedWeekdays.includes(wd.value)
															? classes.weekdayChipSelected
															: classes.weekdayChip
													}
													onClick={() => toggleWeekday(wd.value)}
													color={
														selectedWeekdays.includes(wd.value) ? "primary" : "default"
													}
												/>
											))}
										</Grid>
									)}

									{recurrenceType !== "none" && (
										<>
											<Grid item xs={12} md={4}>
												<FormControl size="small" fullWidth variant="outlined">
													<InputLabel id="recurrence-ends-label">Termina</InputLabel>
													<Select
														labelId="recurrence-ends-label"
														value={recurrenceEnds}
														onChange={(e) => setRecurrenceEnds(e.target.value)}
														label="Termina"
													>
														<MenuItem value="never">Nunca</MenuItem>
														<MenuItem value="on_date">Em uma data</MenuItem>
														<MenuItem value="after_count">Após N ocorrências</MenuItem>
													</Select>
												</FormControl>
											</Grid>
											{recurrenceEnds === "on_date" && (
												<Grid item xs={12} md={4}>
													<TextField
														label="Data final"
														type="datetime-local"
														size="small"
														variant="outlined"
														fullWidth
														value={recurrenceUntil}
														onChange={(e) => setRecurrenceUntil(e.target.value)}
														InputLabelProps={{ shrink: true }}
													/>
												</Grid>
											)}
											{recurrenceEnds === "after_count" && (
												<Grid item xs={12} md={4}>
													<TextField
														label="Ocorrências"
														type="number"
														size="small"
														variant="outlined"
														fullWidth
														value={recurrenceCount}
														onChange={(e) =>
															setRecurrenceCount(Math.max(1, Number(e.target.value) || 1))
														}
														inputProps={{ min: 1 }}
													/>
												</Grid>
											)}
										</>
									)}

									{showBusinessDays && (
										<Grid item xs={12}>
											<FormControl size="small" fullWidth variant="outlined">
												<InputLabel id="tipo-dias-label">Dias não úteis</InputLabel>
												<Select
													labelId="tipo-dias-label"
													value={tipoDias}
													onChange={(e) => setTipoDias(e.target.value || 4)}
													label="Dias não úteis"
												>
													<MenuItem value={4}>Enviar normalmente em dias não úteis</MenuItem>
													<MenuItem value={5}>Enviar um dia útil antes</MenuItem>
													<MenuItem value={6}>Enviar um dia útil depois</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									)}
								</Grid>

								{(schedule.mediaPath || attachment) && (
									<Grid xs={12} item>
										<Button startIcon={<AttachFile />}>
											{attachment ? attachment.name : schedule.mediaName}
										</Button>
										<IconButton onClick={() => setConfirmationOpen(true)} color="secondary">
											<DeleteOutline color="secondary" />
										</IconButton>
									</Grid>
								)}
							</DialogContent>
							<DialogActions>
								{!attachment && !schedule.mediaPath && (
									<Button
										color="primary"
										onClick={() => attachmentFile.current.click()}
										disabled={isSubmitting}
										variant="outlined"
									>
										{i18n.t("quickMessages.buttons.attach")}
									</Button>
								)}
								<Button
									onClick={handleClose}
									color="secondary"
									disabled={isSubmitting}
									variant="outlined"
								>
									{i18n.t("scheduleModal.buttons.cancel")}
								</Button>
								{(schedule.sentAt === null || schedule.sentAt === "") && (
									<Button
										type="submit"
										color="primary"
										disabled={isSubmitting}
										variant="contained"
										className={classes.btnWrapper}
									>
										{scheduleId
											? `${i18n.t("scheduleModal.buttons.okEdit")}`
											: `${i18n.t("scheduleModal.buttons.okAdd")}`}
										{isSubmitting && (
											<CircularProgress size={24} className={classes.buttonProgress} />
										)}
									</Button>
								)}
							</DialogActions>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default ScheduleModal;
